import qs from "qs";
export function getQuery() {
    var _a = qs.parse(window.location.href.split("?")[1]), uuid = _a.uuid, token = _a.token, tmp = _a.tmp, code = _a.code;
    return { uuid: uuid, token: token, tmp: tmp, code: code };
}
